import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timeAgo',
    standalone: true,
})
export class TimeAgoPipe implements PipeTransform {
    transform(input: string | Date): string {
        const inputDate = typeof input === 'string' ? new Date(input) : input;

        const currentDate = new Date();
        const currentOffset = currentDate.getTimezoneOffset() * 60000; // current date offset millisec
        const utcCurrentDate = currentDate.getTime() + currentOffset; // current date UTC

        // Calcola la differenza in millisecondi
        const timeAgo = Math.abs(utcCurrentDate - inputDate.getTime());

        if (timeAgo < 1000) {
            return '1 second ago';
        }

        const timeDemarcations = [
            { unit: 'seconds', demarcation: 1000 },
            { unit: 'minutes', demarcation: 60 },
            { unit: 'hours', demarcation: 60 },
            { unit: 'days', demarcation: 24 },
            { unit: 'weeks', demarcation: 7 },
        ];

        let i = 0;
        let value = timeAgo;

        while (i < timeDemarcations.length && value >= timeDemarcations[i].demarcation) {
            value /= timeDemarcations[i].demarcation;
            i += 1;
        }

        const isSingular = Math.floor(value) === 1;
        return `${Math.floor(value)} ${isSingular ? timeDemarcations[i - 1].unit.slice(0, -1) : timeDemarcations[i - 1].unit} ago`;
    }
}
